import { useEffect, useState } from "react";

/**
 * Tracks window scroll Y with requestAnimationFrame throttling.
 * Returns 0 if the user prefers reduced motion, so components using this
 * for parallax effects naturally disable themselves.
 */
export default function useScrollY() {
  const [y, setY] = useState(0);

  useEffect(() => {
    // Respect reduced motion — bail out entirely and leave y at 0.
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setY(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return y;
}
